import { Link } from 'react-router-dom';
import {
  GlobeHemisphereWest,
  Scroll,
  VideoCamera,
  PenNib,
  Stamp,
  IdentificationCard,
  Heart,
  FileText,
  Fingerprint,
  ArrowRight,
} from '@phosphor-icons/react';

export const ServicesGrid = () => {
  const allServices = [
    {
      icon: GlobeHemisphereWest,
      name: "Apostille & International Certification",
      description: "Expedited Tennessee SOS apostille for births, marriages, diplomas, and corporate filings.",
      link: "/services/apostille",
    },
    {
      icon: Scroll,
      name: "Estate Planning Documents",
      description: "Trust packages, healthcare directives, and POA packages — handled with discretion.",
      link: "/services/estate-planning",
    },
    {
      icon: VideoCamera,
      name: "Remote Online Notarization",
      description: "Tennessee-compliant audio-visual notarization from anywhere in the world.",
      link: "/services/remote-online-notarization",
    },
    {
      icon: PenNib,
      name: "Loan Document Signing",
      description: "Certified Notary Signing Agent for refinances, purchases, HELOCs, and reverse mortgages.",
      link: "/services/loan-signing",
    },
    {
      icon: Stamp,
      name: "General Mobile Notary",
      description: "Affidavits, sworn statements, vehicle titles, parental consent — anywhere in Nashville.",
      link: "/services/general-notary",
    },
    {
      icon: Heart,
      name: "Wedding Officiant",
      description: "Personalized ceremonies — elopements, courthouse, micro-weddings, and vow renewals.",
      link: "/services/wedding-officiant",
    },
    {
      icon: Fingerprint,
      name: "Fingerprinting & Background Checks",
      description: "Live-scan fingerprinting and background check services for licensing, employment, and adoptions.",
      link: "/services/fingerprinting",
    },
    {
      icon: IdentificationCard,
      name: "I-9 Employment Verification",
      description: "USCIS-compliant on-site I-9 verification for Nashville employers and remote hires.",
      link: "/services/i9-verification",
    },
    {
      icon: FileText,
      name: "Process Serving",
      description: "Reliable legal document delivery with court-ready proof of service.",
      link: "/services/process-serving",
    },
  ];

  return (
    <section data-testid="services-grid-section" className="py-24 bg-[#FBF8F1] relative">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 h-px w-32 bg-gradient-to-r from-transparent via-[#D4AF37] to-transparent" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16 max-w-3xl mx-auto">
          <div className="inline-flex items-center gap-3 mb-6">
            <div className="h-px w-8 bg-[#800000]" />
            <span className="text-[#800000] text-xs font-semibold tracking-[0.3em] uppercase">Complete Notary Services</span>
            <div className="h-px w-8 bg-[#800000]" />
          </div>
          <h2 className="font-serif-display text-4xl sm:text-5xl font-semibold text-[#800000] mb-5">
            Services <span className="italic">Offered</span>
          </h2>
          <p className="text-base sm:text-lg text-[#5C5C5C] leading-relaxed">
            From apostille and estate signings to wedding ceremonies and live-scan fingerprinting — one trusted Nashville notary for every document, every milestone, every moment.
          </p>
        </div>

        {/* Uniform 3 × 3 services grid */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {allServices.map((service, idx) => (
            <Link
              key={idx}
              to={service.link}
              data-testid={`service-card-${idx}`}
              className="group bg-white border border-[#E8E2D5] hover:border-[#800000]/30 p-7 rounded-sm transition-all duration-300 hover:shadow-xl hover:-translate-y-0.5 block"
            >
              <div className="w-12 h-12 rounded-full flex items-center justify-center mb-4 bg-[#800000]/5 group-hover:bg-[#800000]/10 transition-colors">
                <service.icon
                  weight="duotone"
                  size={24}
                  className="text-[#800000]"
                />
              </div>

              <h3 className="font-serif-display text-lg font-semibold text-[#800000] mb-2 leading-tight">
                {service.name}
              </h3>

              <p className="text-[#5C5C5C] leading-relaxed text-sm">
                {service.description}
              </p>

              <div className="mt-4 inline-flex items-center gap-1.5 text-xs font-semibold uppercase tracking-wider text-[#800000]">
                Learn More
                <ArrowRight weight="bold" size={12} className="group-hover:translate-x-1 transition-transform" />
              </div>
            </Link>
          ))}
        </div>

        {/* CTA */}
        <div className="text-center mt-16">
          <Link
            to="/booking"
            data-testid="services-grid-book-btn"
            className="inline-flex items-center gap-3 bg-[#800000] text-white hover:bg-[#5C0000] transition-all px-10 py-4 rounded-sm font-semibold text-sm tracking-[0.15em] uppercase shadow-lg hover:shadow-xl"
          >
            Book Any Service
            <ArrowRight weight="bold" size={18} />
          </Link>
        </div>
      </div>
    </section>
  );
};
